module.exports = __webpack_public_path__ + "static/media/BTSManual.539b8aae.pdf";